import React from "react";
import { Modal, Text, Banner, LegacyStack } from "@shopify/polaris";

interface ConfirmProps {
  isOpen: boolean;
  resourcesCount: number;
  affectedSubscriptionsCount: number;
  onCancelUpdate: () => void;
  onNext: () => void;
}

export default function ({
  isOpen,
  resourcesCount,
  affectedSubscriptionsCount,
  onCancelUpdate,
  onNext,
}: ConfirmProps): React.JSX.Element {
  return (
    <Modal
      open={isOpen}
      onClose={onCancelUpdate}
      title="Confirm price update"
      primaryAction={{
        content: "Confirm",
        onAction: onNext,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: onCancelUpdate,
        },
      ]}
    >
      <Modal.Section>
        <LegacyStack spacing="loose" vertical>
          <Text variant="bodyMd" as="p">
            This will update subscription prices for {resourcesCount}{" "}
            {resourcesCount === 1 ? "product" : "products"} across&nbsp;
            {affectedSubscriptionsCount} {affectedSubscriptionsCount === 1 ? "subscription" : "subscriptions"}.
            Changes take effect on each subscriber&apos;s next billing cycle.
          </Text>

          <Text variant="bodyMd" as="p">
            This will only update the line item base price. Selling plans, discounts, and billing schedules will
            not be modified.
          </Text>

          <Banner status="warning">
            <Text variant="bodyMd" as="p" color="warning">
              <Text as="span" fontWeight="semibold">
                Legal best practice:
              </Text>{" "}
              Many jurisdictions require advance notice before raising recurring subscription prices. Consider
              notifying your customers in the next step.
            </Text>
          </Banner>
        </LegacyStack>
      </Modal.Section>
    </Modal>
  );
}
